import React from 'react';

const AboutUs = () => {
    return (
        <div>
            About Us
            <div>
                   Our Story: Our warehouse management website stareted at 28th April, 2022. 
            </div>
            <div>

            </div>
        </div>
    );
};

export default AboutUs;